/**
 * Must stay in sync with `$accent-orange` in `app/styles/global.scss`.
 */
export const ACCENT_ORANGE = "#f58221";

/**
 * Matches `$primary-color` and `.form-title-heading` (e.g. "EDIT TIMESHEET" title).
 */
export const PRIMARY_BRAND = "#D15207";
